import { useQueryWithEndpoint } from "@hydrologiq/shared/hooks/useGraphQLClient"
import { GetAlertsKanbanDocument } from "@hydrologiq/gql-experience/graphql"

export interface AlertsKanbanData {
  alerts: {
    new: any[]
    in_progress: any[]
    on_hold: any[]
    completed: any[]
  }
  headlines: {
    new_issues?: { count: number; critical: number; warning: number; info: number }
    in_progress_issues?: {
      count: number
      critical: number
      warning: number
      info: number
      acknowledged: number
      attended: number
    }
    on_hold_issues?: { count: number; critical: number; warning: number; info: number }
    completed_issues?: { count: number }
    customers_affected?: number
    systems_affected?: number
    resolution_time_hours?: number | null
    resolution_time_hours_7_14d?: number | null
  }
  assignable_users: any[]
  system_order_ids: string[]
  pinned_system_ids: string[]
}

export function useAlertsKanban() {
  const { data, loading, error, refetch } = useQueryWithEndpoint(
    GetAlertsKanbanDocument,
    {
      notifyOnNetworkStatusChange: false,
      pollInterval: 60000,
    },
    "primary",
  )

  return {
    data: data?.getAlertsKanban as AlertsKanbanData | undefined,
    loading,
    error,
    refetch,
  }
}
